export enum MemberType {
  Constructor,
  Method,
  Property,
  Event,
}

